"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AvailabilityForNewPatients = _interopRequireDefault(require("./AvailabilityForNewPatients"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _AvailabilityForNewPatients.default;
exports.default = _default;